<template>
  <div class="user-search">
    <img src="@/assets/images/icons/search_grey.svg" alt="search" />
    <input
      type="text"
      placeholder="Search Users"
      v-model="text"
      @input="setConversationSearchText(text)"
    />
  </div>
</template>

<script>
import { mapMutations } from "vuex"
export default {
  data: function () {
    return {
      text: "",
    }
  },
  methods: {
    ...mapMutations("Message", ["setConversationSearchText"]),
  },
}
</script>

<style lang="scss" scoped>
// @import "@/assets/style/_mixins.scss";
@import "@/assets/style/_variables.scss";
.user-search {
  display: flex;
  align-items: center;
  background: #f0f0f0;
  border-radius: 200px;
  height: 3rem;
  padding: 0 1rem;
  margin-right: 1rem;
  input {
    flex: auto;
    outline: none;
    border: none;
    background: #f0f0f0;
    color: #999;
    font-family: $font-roboto;
    padding: 0 0.5rem;
    &::placeholder {
      color: rgba(153, 153, 153, 0.5);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/message_widget/ConversationSearch.vue